import { Platform, useWindowDimensions } from "@-/com.npmjs.react-native";

/**
 * Below this window width (web only — native is ALWAYS collapsed) the 240px section rail would
 * leave the content column narrower than a phone, so the rail collapses into a pill row.
 * `md` in Tailwind terms. The Reference e2e spec pins a 1280px viewport and expects the rail.
 */
const RAIL_MIN_WINDOW_WIDTH = 768;

/**
 * Whether the Reference page's section navigation collapses from a side rail into a pill row.
 * Native never shows the web rail (a phone, or even an iPad column, is a single narrow column);
 * web collapses below `RAIL_MIN_WINDOW_WIDTH`.
 */
export function useIsMorphemeInfoPanelSidebarCollapsed(): boolean {
  const { width } = useWindowDimensions();
  return Platform.OS !== "web" || width < RAIL_MIN_WINDOW_WIDTH;
}
